import React from "react";
import PropTypes from "prop-types";
import { capitalizeFirstLetter } from "../../../../../utils/string-helpers";

export const EmptyFood = ({ label = "foods", variant = "added" }) => {
  const resolvedLabel = label === "all" ? "foods" : label;

  /**
   * Function to remove the last s of the word
   * @param {*} word
   * @returns
   */
  const singular = (word) => {
    return word.endsWith("s") ? word.slice(0, -1) : word;
  };

  /**
   * Get the title to use
   * @param {*} type
   * @returns
   */
  const getTitle = (type) => {
    if (type === "recent") {
      return `No Recent ${capitalizeFirstLetter(resolvedLabel)} Yet`;
    }
    return `No ${singular(resolvedLabel)} added`;
  };

  /**
   * Get the subtitle to use
   * @param {*} type
   * @returns
   */
  const getSubtitle = (type) => {
    if (type === "recent") {
      return `Start by adding your first ${resolvedLabel} — it’ll show up here next time for quick access.`;
    }
    const context = type === "meal" ? "the meal" : "the meal planner";
    return `To add ${singular(
      resolvedLabel
    )} to ${context}, search for ${singular(
      resolvedLabel
    )} above and add it to the list.`;
  };

  const titleMap = {
    added: getTitle("added"),
    meal: getTitle("meal"),
    recent: getTitle("recent"),
  };

  const subtitleMap = {
    added: getSubtitle("added"),
    meal: getSubtitle("meal"),
    recent: getSubtitle("recent"),
  };

  return (
    <div className="no-content">
      <div className="flex flex-col gap-4 items-center">
        <span className="font-bold">{titleMap[variant]}</span>
        <span className="opacity-70 text-center w-[70%] text-[0.75rem]">
          {subtitleMap[variant]}
        </span>
      </div>
    </div>
  );
};

EmptyFood.propTypes = {
  label: PropTypes.string,
  variant: PropTypes.oneOf(["added", "recent", "meal"]),
};
